import moment from "moment";

export default function localizedDate(date, format="YYYY-MM-DD HH:mm:ss") {
  if (!date) {
    return null;
  }
  return moment
    .utc(date)
    .local()
    .format(format)
    .toString();
}
